// extracted by mini-css-extract-plugin
export var completionBody = "_kp-2";
export var completionCard = "_kp-0";
export var completionFooter = "_kp-3";
export var completionTitle = "_kp-1";